import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  return {
    ...state,
    versetzungsplaene: [
      {
        ...state.versetzungsplaene[0],
        termine: result,
      },
    ],
    isLoading: false,
  }
}

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export async function action(payload) {
  try {
    return await Api.updateTermin(payload.id, payload.subject, payload.from, payload.to)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
